export { default } from "./ResponsiveBannerImage.jsx";
